// extracted by mini-css-extract-plugin
export default {"wrapper":"PaidResultsPage_wrapper__mrrJ4"};